<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(user.id)" v-if="user.id && $can('user-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('users.first_name')"
                  :error-messages="errors.collect('person.first_name')"
                  data-vv-name="person.first_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    v-model="person.middle_name"
                                    v-validate="'max:50'"
                                    :label="$t('users.middle_name')"
                                    :error-messages="errors.collect('person.middle_name')"
                                    data-vv-name="person.middle_name"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.last_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('users.last_name')"
                  :error-messages="errors.collect('person.last_name')"
                  data-vv-name="person.last_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.mobile"
                  class="required-field"
                  v-validate="'required|max:20|no_space'"
                  :label="$t('users.mobile')"
                  :error-messages="errors.collect('person.mobile')"
                  data-vv-name="person.mobile"
                  name="person.mobile"
                  @blur="phoneNoSpace"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("users.account_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="user.email"
                  class="required-field"
                  v-validate="'required|max:255'"
                  :label="$t('users.email')"
                  :error-messages="errors.collect('user.email')"
                  data-vv-name="user.email"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="user && user.id">
                <v-text-field
                  v-model="user.password"
                  :class="!user.id ? 'required-field' : ''"
                  v-validate="!user.id ? 'required|password_strength' : 'password_strength'"
                  :label="$t('users.password')"
                  :error-messages="errors.collect('user.password')"
                  data-vv-name="user.password"
                  type="password"
                  :hint="$t('global.helptext_password')"
                  persistent-hint
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="user.status"
                  v-model="user.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_user_status()"
                  :label="$t('users.status')"
                  :error-messages="errors.collect('user.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("roles.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-form ref="form">
              <v-flex md12>
                <span v-for="all_role in all_roles" :key="all_role.id" class="mr-3">
                  <input
                    v-model="checked"
                    type="checkbox"
                    name="chk_role"
                    :value="all_role.name"
                    :checked="checked.includes(all_role.name)"
                  />
                  {{ all_role.name }}
                </span>
              </v-flex>
              <v-flex sm6 xs12 v-if="isOrganisationAdminRole">
                <v-autocomplete
                  name="organisations.title"
                  v-model="user.organisation_ids"
                  class="required-field"
                  v-validate="'required'"
                  :items="organisations"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.title')"
                  :error-messages="errors.collect('organisations.title')"
                  autocomplete="new-password"
                  clearable
                  multiple
                ></v-autocomplete>
              </v-flex>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "UserForm",

  props: ["id"],

  data() {
    return {
      page_title: "",

      predata: {},
      user: {
        id: this.id
      },
      person: {},

      roles: [],
      all_roles: [],
      checked: [],

      dictionary: {
        attributes: {
          "user.email": this.$t("users.email"),
          "user.password": this.$t("users.password"),
          "user.status": this.$t("users.status"),

          "person.first_name": this.$t("users.first_name"),
          //"person.middle_name": this.$t("users.middle_name"),
          "person.last_name": this.$t("users.last_name"),
          "person.mobile": this.$t("users.mobile"),
          "person.comments": this.$t("users.comments"),

          "organisations.title": this.$t("organisations.title")
        }
      },
      organisations: []
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.user, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    isOrganisationAdminRole() {
      let role = this.all_roles.find((i) => i.slug == "organisation-admin")
      return Boolean(role && this.checked.includes(role.name))
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.user.id) {
      this.page_title = this.$t("users.new_user")

      this.user = {}

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.user))

      this.ddlists()
    } else {
      axios
        .get(this.API_URL + "user/" + this.id)
        .then((res) => {
          this.user = res.data.data
          this.user.organisation_ids = this.user.organisations.map((i) => i.organisation_id)
          this.person = res.data.data.person
          this.roles = res.data.data.roles

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.user))

          this.page_title = this.$t("users.edit_user", {
            name: this.person.first_name + " " + this.person.last_name
          })

          this.ddlists()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    ddlists() {
      let vm = this

      this.roles.forEach(function(value) {
        vm.checked.push(value.name)
      })

      let lists = [
        {
          key: "roles",
          module: "roles",
          query: "show_all=true"
        },
        {
          key: "organisations",
          module: "organisations",
          query: "show_all=true&resourcetype=organisation-basic"
        }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.organisations = res.data.organisations

        let roles = res.data.roles
        roles = _.orderBy(roles, ["name"], ["asc"])
        this.all_roles = roles
      })
    },
    saveRoles(id) {
      let vm = this

      axios
        .post(this.API_URL + "user/roles", {
          id: id,
          roles: vm.checked
        })
        .then((res) => {
          let data = res.data.data

          if (data.id) {
            vm.$store.dispatch("auth/updateUserState", vm)
          }
        })
        .catch((err) => console.log(err))
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.user.id) {
              // Create
              axios
                .post(this.API_URL + "user", {
                  email: vm.user.email,
                  password: vm.user.password,
                  status: vm.user.status,
                  person: {
                    first_name: vm.person.first_name,
                    last_name: vm.person.last_name,
                    middle_name: vm.person.middle_name,
                    mobile: vm.person.mobile
                  },
                  organisation_ids: vm.isOrganisationAdminRole ? vm.user.organisation_ids : null
                })
                .then((res) => {
                  vm.user = res.data.data
                  vm.user.organisation_ids = vm.user.organisations.map((i) => i.organisation_id)
                  vm.predata = JSON.parse(JSON.stringify(vm.user))

                  vm.person = res.data.data.person
                  vm.roles = res.data.data.roles

                  vm.saveRoles(vm.user.id)

                  vm.page_title = vm.$t("users.edit_user", {
                    name: vm.person.first_name + " " + vm.person.last_name
                  })

                  vm.$awn.success(vm.$t("global.create_success"))
                  vm.$router.replace(this.BACKEND_URL + `/users/edit/${vm.user.id}`).catch(() => {})
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "user", {
                  id: vm.user.id,
                  email: vm.user.email,
                  password: vm.user.password,
                  status: vm.user.status,
                  person: {
                    first_name: vm.person.first_name,
                    last_name: vm.person.last_name,
                    middle_name: vm.person.middle_name,
                    mobile: vm.person.mobile,
                    comments: vm.person.comments
                  },
                  organisation_ids: vm.isOrganisationAdminRole ? vm.user.organisation_ids : null
                })
                .then((res) => {
                  vm.user = res.data.data
                  vm.user.organisation_ids = vm.user.organisations.map((i) => i.organisation_id)
                  vm.predata = JSON.parse(JSON.stringify(vm.user))

                  vm.person = res.data.data.person
                  vm.roles = res.data.data.roles

                  vm.saveRoles(vm.user.id)

                  vm.page_title = vm.$t("users.edit_user", {
                    name: vm.person.first_name + " " + vm.person.last_name
                  })
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "user/" + id)
            .then(() => {
              vm.$router.push(vm.BACKEND_URL + "/users")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    phoneNoSpace() {
      if (this.person.mobile) {
        this.person.mobile = this.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "person.mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    }
  }
}
</script>

<style scoped></style>
